var exports = {
  "kL": "xdde3148b--c6725d--container",
  "pq": "xdde3148b--c6725d--info",
  "o1": "xdde3148b--c6725d--actions",
};

module.exports = exports;
